import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["data-item-id", "data-item-number"];
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = {
    key: 1,
    class: "catalog-item__image-placeholder"
};
const _hoisted_4 = { class: "catalog-item__product" };
const _hoisted_5 = { class: "catalog-item__category" };
const _hoisted_6 = { class: "catalog-item__title" };
const _hoisted_7 = {
    key: 0,
    class: "catalog-item__item-number"
};
const _hoisted_8 = {
    key: 0,
    class: "catalog-item__attributes"
};
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "catalog-item__delivery" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = {
    key: 1,
    class: "catalog-item__actions"
};
const _hoisted_13 = { class: "catalog-item__price" };
const _hoisted_14 = {
    key: 0,
    class: "catalog-item__price-info"
};
const _hoisted_15 = {
    key: 0,
    class: "catalog-item__price-base"
};
const _hoisted_16 = {
    key: 1,
    class: "catalog-item__price-ordering"
};
const _hoisted_17 = ["title"];
const _hoisted_18 = ["title"];
import { ref, computed, watch } from "vue";
import Icon from '@astina/paloma-common-ui/src/components/Icon.vue';
import CatalogItemActions2 from '@astina/paloma-shop-common-ui/src/components/CatalogItemActions2.vue';
import ProductAttributeValue from '@astina/paloma-shop-common-ui/src/components/ProductAttributeValue.vue';
import Price from '@astina/paloma-shop-common-ui/src/components/Price.vue';
import { addCartItems } from "../commands/AddCartItems";
import config from "../services/PortalConfig";
import { addWatchlistItem } from "../commands/AddWatchlistItems";
import { useClickaway } from "@astina/paloma-common-ui/src/composables/clickaway";
import { useUnavailabilityReason } from "../services/UnavailabilityReason";
import trans from "@astina/paloma-common-ui/src/services/Translator";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogListItem',
    props: {
        item: {},
        viewMode: {}
    },
    emits: ['cart-item-draft-change'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const unavailable = computed(() => {
            // unavailable if no variants are available
            return !props.item.variants.some(variant => variant.availability?.available)
                // or if no variant has a price
                || !props.item.variants.find(variant => variant.price);
        });
        const interrupted = computed(() => {
            return unavailable.value
                && props.item.variants.some(variant => (variant.availability?.unavailabilityReasons || []).indexOf('interrupted') >= 0);
        });
        const attributes = computed(() => {
            return props.item.attributes.map(attr => {
                const values = [];
                for (let i = 0; i < attr.values.length; i++) {
                    const value = attr.values[i];
                    const valueCode = attr.valueCodes[i];
                    values.push({
                        attribute: attr,
                        value: value,
                        valueCode: valueCode
                    });
                }
                return values;
            });
        });
        const showCartActions = ref(false);
        const addCartItemsFunction = addCartItems;
        const addWatchlistItemFunction = addWatchlistItem;
        const cartEl = ref(null);
        useClickaway(cartEl, () => showCartActions.value = false);
        const { getUnavailabilityReason } = useUnavailabilityReason();
        const unavailabilityText = computed(() => {
            const variant = props.item.variants.find(v => v.availability?.unavailabilityReasons?.length);
            return variant
                ? getUnavailabilityReason(variant.availability)
                : trans("product.no_variants_available");
        });
        // prevent the item actions from getting behind the category sidebar
        const catalogItemActionsEl = ref(null);
        watch(showCartActions, () => {
            if (showCartActions.value) {
                window.setTimeout(() => {
                    itemActionsStyle.value = calculateItemActionsStyle();
                }, 50);
            }
            else {
                itemActionsStyle.value = {};
            }
        });
        const itemActionsStyle = ref(() => { });
        function calculateItemActionsStyle() {
            const el = catalogItemActionsEl.value?.$el;
            if (el && typeof el.getBoundingClientRect === 'function') {
                const rect = el.getBoundingClientRect();
                if (rect.x < 300 && window.innerWidth > 1000) {
                    const right = rect.x - 300;
                    return { right: `${right}px`, transition: 'right 0.3s ease' };
                }
            }
            return {};
        }
        const differentBaseUnitPrice = computed(() => {
            if (!props.item.baseUnitPrice) {
                return false;
            }
            return props.item.baseUnitPrice.unit !== props.item.baseOrderingUnitPrice?.unit
                || props.item.baseUnitPrice.price !== props.item.baseOrderingUnitPrice?.price;
        });
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["catalog-item", {
                        'catalog-item--grid': __props.viewMode === 'grid',
                        'catalog-item--list': __props.viewMode === 'list' || __props.viewMode === 'bulk',
                        'catalog-item--bulk': __props.viewMode === 'bulk'
                    }]),
                "data-item-id": __props.item.id,
                "data-item-number": __props.item.itemNumber
            }, [
                _createVNode(_component_RouterLink, {
                    to: { name: 'catalog_category_product', params: { id: __props.item.id } },
                    class: "catalog-item__image"
                }, {
                    default: _withCtx(() => [
                        (__props.item.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: __props.item.image,
                                alt: __props.item.title
                            }, null, 8, _hoisted_2))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(Icon, {
                                    name: "image",
                                    "icon-style": "light"
                                })
                            ]))
                    ]),
                    _: 1
                }, 8, ["to"]),
                _cache[13] || (_cache[13] = _createTextVNode()),
                _createVNode(_component_RouterLink, {
                    to: { name: 'catalog_category_product', params: { id: __props.item.id } },
                    class: "catalog-item__content"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(__props.item.category), 1),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.item.title), 1),
                            _cache[5] || (_cache[5] = _createTextVNode()),
                            (__props.item.itemNumber)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('catalog.item_number', { itemNumber: __props.item.itemNumber })), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        (__props.viewMode !== 'bulk')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attribute, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: _normalizeClass(["catalog-item__attribute", 'catalog-item__attribute--type-' + attribute[0].attribute.type])
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attribute, (value, index2) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: "catalog-item__attribute-value",
                                                key: index2
                                            }, [
                                                _createVNode(ProductAttributeValue, {
                                                    attribute: value.attribute,
                                                    value: value.value,
                                                    "value-code": value.valueCode
                                                }, null, 8, ["attribute", "value", "value-code"])
                                            ]));
                                        }), 128))
                                    ], 2));
                                }), 128)),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                (__props.item.earliestDeliveryDate)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createVNode(Icon, { name: "delivery" }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('catalog.item_delivery_date', { date: _ctx.$date(__props.item.earliestDeliveryDate) })), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["to"]),
                _cache[14] || (_cache[14] = _createTextVNode()),
                (__props.viewMode === 'bulk')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(CatalogItemActions2, {
                            product: __props.item,
                            "add-cart-items": _unref(addCartItemsFunction),
                            "add-watchlist-item": _unref(addWatchlistItemFunction),
                            "allow-ordering-unit-selection": _unref(config).articleOrderingUnitSelection === 'allow',
                            onCartItemDraftChange: _cache[0] || (_cache[0] = ($event) => (emit('cart-item-draft-change', $event)))
                        }, null, 8, ["product", "add-cart-items", "add-watchlist-item", "allow-ordering-unit-selection"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            (__props.item.priceInfo)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(__props.item.priceInfo), 1))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (__props.item.baseUnitPrice && differentBaseUnitPrice.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createVNode(Price, {
                                                currency: __props.item.baseUnitPrice.currency,
                                                amount: __props.item.baseUnitPrice.price,
                                                original: __props.item.baseUnitPrice.originalPrice,
                                                unit: __props.item.baseUnitPrice.unit
                                            }, null, 8, ["currency", "amount", "original", "unit"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    (__props.item.baseOrderingUnitPrice)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createVNode(Price, {
                                                currency: __props.item.baseOrderingUnitPrice.currency,
                                                amount: __props.item.baseOrderingUnitPrice.price,
                                                original: __props.item.baseOrderingUnitPrice.originalPrice,
                                                unit: __props.item.baseOrderingUnitPrice.unit
                                            }, null, 8, ["currency", "amount", "original", "unit"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64))
                        ]),
                        _cache[12] || (_cache[12] = _createTextVNode()),
                        _createElementVNode("div", {
                            class: "catalog-item__cart",
                            ref_key: "cartEl",
                            ref: cartEl
                        }, [
                            (interrupted.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "catalog-item__button",
                                    title: unavailabilityText.value
                                }, [
                                    _createVNode(Icon, {
                                        name: "ban",
                                        "icon-style": "light"
                                    })
                                ], 8, _hoisted_17))
                                : _createCommentVNode("", true),
                            _cache[11] || (_cache[11] = _createTextVNode()),
                            (_ctx.$isGranted('PORTAL_ORDERS_CREATE'))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (!interrupted.value)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: _normalizeClass(["catalog-item__button", { 'catalog-item__button--disabled': unavailable.value }]),
                                            title: _ctx.$t('cart'),
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (!unavailable.value && (showCartActions.value = !showCartActions.value)), ["prevent"])),
                                            href: "#"
                                        }, [
                                            _createVNode(Icon, {
                                                name: "cart",
                                                "icon-style": "light"
                                            })
                                        ], 10, _hoisted_18))
                                        : _createCommentVNode("", true),
                                    _cache[9] || (_cache[9] = _createTextVNode()),
                                    _createVNode(Icon, {
                                        name: "watchlist",
                                        title: _ctx.$t('watchlist'),
                                        "icon-style": "light",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (showCartActions.value = !showCartActions.value))
                                    }, null, 8, ["title"]),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    (showCartActions.value)
                                        ? (_openBlock(), _createBlock(CatalogItemActions2, {
                                            key: 1,
                                            ref_key: "catalogItemActionsEl",
                                            ref: catalogItemActionsEl,
                                            product: __props.item,
                                            "add-cart-items": _unref(addCartItemsFunction),
                                            "add-watchlist-item": _unref(addWatchlistItemFunction),
                                            "allow-ordering-unit-selection": _unref(config).articleOrderingUnitSelection === 'allow',
                                            onCartItemDraftChange: _cache[3] || (_cache[3] = ($event) => (emit('cart-item-draft-change', $event))),
                                            style: _normalizeStyle(itemActionsStyle.value)
                                        }, null, 8, ["product", "add-cart-items", "add-watchlist-item", "allow-ordering-unit-selection", "style"]))
                                        : _createCommentVNode("", true)
                                ], 64))
                                : _createCommentVNode("", true)
                        ], 512)
                    ]))
            ], 10, _hoisted_1));
        };
    }
});
